export default __webpack_public_path__ + "static/media/backgroundHorizontal.799fdd29.jpg";